import { Vue } from 'vue-property-decorator'
import { SamaeRepository } from './SamaeRepository'
import { JtechStore } from 'src/plugins/mobx'

export default class SamaeController {
  static getInstance () {
    return JtechStore.getSingleton('SamaeController', new SamaeController())
  }

  async importFile () {
    const forms = await SamaeRepository.importFile()
    const datatable = await SamaeRepository.files()
    return { forms, datatable }
  }

  async units (params) {
    return await SamaeRepository.units(params)
  }

  async processFile (params) {
    return await SamaeRepository.processFile(params)
  }

  async icGerarDocumento (params) {
    return await SamaeRepository.icGerarDocumento(params)
  }

  async icFinancialProcess (params) {
    return await SamaeRepository.icFinancialProcess(params)
  }

  async processExportFile (nameFile) {
    return await SamaeRepository.processExportFile(nameFile)
  }

  async joinUnit (params) {
    return await SamaeRepository.joinUnit(params)
  }

  async unitStateSamae (params) {
    return await SamaeRepository.unitStateSamae(params)
  }

  async unitStateSamaeDetail (params) {
    return await SamaeRepository.unitStateSamaeDetail(params)
  }

  async analyze (params) {
    return await SamaeRepository.analyze(params)
  }

  async stateSamaes (params) {
    return await SamaeRepository.stateSamaes(params)
  }

  async unitStateSamaeUnitDisabled (params) {
    return await SamaeRepository.unitStateSamaeUnitDisabled(params)
  }

  async unitStateSamaeClientChange (params) {
    return await SamaeRepository.unitStateSamaeClientChange(params)
  }

  async unitStateSamaeUnitNew (params) {
    return await SamaeRepository.unitStateSamaeUnitNew(params)
  }

  async unitStateSamaeUnitNewAssociate (params) {
    return await SamaeRepository.unitStateSamaeUnitNewAssociate(params)
  }

  async unitAlterSamaeDisabledForm (params) {
    return await SamaeRepository.unitAlterSamaeDisabledForm(params)
  }

  async findConsumerUnitByConvag (params) {
    return await SamaeRepository.findConsumerUnitByConvag(params)
  }

  async alterPaymentType (params) {
    return await SamaeRepository.alterPaymentType(params)
  }
}
